<cac-dialog-layout title="رکوردهای با تاخیر" [hideControls]="true">
  <cac-table [options]="table"></cac-table>
</cac-dialog-layout>
